module.exports = __webpack_public_path__ + "img/4-1-3-3-preview-staycationoffers-c.a9b575b3.jpg";